import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text, TextVariantUnionType} from "@pg-design/text-module";

interface IProps {
    iconSlot: ReactNode;
    titleSlot?: ReactNode;
    descriptionSlot?: ReactNode;
    descriptionVariant?: TextVariantUnionType;
}

export const AuthModalBenefitDescriptionBulletItem = ({iconSlot, titleSlot, descriptionSlot, descriptionVariant = "body_copy_2"}: IProps) => {
    return (
        <div className={bulletItemWrapperStyle}>
            <div className={bulletItemIconWrapperStyle}>{iconSlot}</div>
            <div>
                {titleSlot && (
                    <Text variant="headline_4" mb={1}>
                        {titleSlot}
                    </Text>
                )}

                {descriptionSlot && <Text variant={descriptionVariant}>{descriptionSlot}</Text>}
            </div>
        </div>
    );
};

const bulletItemWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    columnGap: 2
});

const bulletItemIconWrapperStyle = css({
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "5.6rem",
    height: "5.6rem"
});
